module.exports = __webpack_public_path__ + "img/13.a5509549.jpg";